// Shared by every capped list in the docs nav: Suggestions, Agent, Internal. Styled
// like the section label and aligned to the same left edge. No count: it reflows
// as articles are added and changes nobody's decision to expand.
export const DocsShowAllToggle = ({
	isExpanded,
	onToggle,
}: {
	isExpanded: boolean
	onToggle: () => void
}) => (
	<button
		type="button"
		onClick={onToggle}
		className="mt-0.5 flex w-full cursor-default select-none items-center rounded-md px-2 py-1 text-left text-xs font-medium text-tertiary hover:bg-gray-100 hover:text-primary dark:hover:bg-gray-800"
	>
		<span className="truncate">{isExpanded ? "Show less" : "View all"}</span>
	</button>
)
